import {Component, Inject, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Select} from "@ngxs/store";
import {Observable} from "rxjs/internal/Observable";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Database, University, UniversityField, WidgetFilter} from "../../core/models";
import {debounceTime, filter, map, reduce, startWith, switchMap, takeUntil} from "rxjs/operators";
import {from, Subject} from "rxjs/index";
import {MatTableDataSource} from "@angular/material/table";
import {CoreService} from "../../core/services/core.service";
import {FilterUniversityDialogComponent} from "../filter-university-dialog/filter-university-dialog.component";
import {RatingSelectDialogComponent} from "../rating-select-dialog/rating-select-dialog.component";


@Component({
  selector: 'app-filter-similar-dialog',
  templateUrl: './filter-similar-dialog.component.html',
  styleUrls: ['./filter-similar-dialog.component.scss']
})
export class FilterSimilarDialogComponent implements OnInit {

  buttonLabel = 'Добавить';

  form: FormGroup;

  // @Select((s) => s.core.universities) universities$;
  @Select((s) => s.core.universityFields) universityFields$;
  @Select((s) => s.core.database) database$;
  // universities = [];
  universityFields = [];
  filteredUniversities: Observable<string[]>;
  filteredUniversityFields: Observable<string[]>;
  destroyed$ = new Subject();

  loading: boolean = false;
  loaded: boolean = false;
  displayedColumns = ['country', 'name'];
  dataSource: MatTableDataSource<any>;
  universitiesCount: number = 100;

  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<FilterSimilarDialogComponent>,
              private coreService: CoreService,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) private data: WidgetFilter) {

    this.prepareOptions();

    this.form = this.formBuilder.group({
      'type': ['reference'],
      'op':  ['='],
      'val': [data ? data.val : null],
      'university': [data ? data.university : null, Validators.required],
      'indicators': [data ? this.getIndicatorsNames(data.indicators) : null, Validators.required],
      // 'method': [data ? this.methods.filter((v) => v.value == data.method)[0] : this.methods[0]],
      'indicatorsFilter': [data ? data.indicatorsFilter : null],
      'count': [data ? data.count : 1, [
        Validators.min(1),
        Validators.required,
        (control: AbstractControl) => Validators.max(this.universitiesCount)(control)]
      ],
    }); //, {'validators': [FilterSimilarDialogComponent.validateForm]});

    this.dataSource = new MatTableDataSource([]);
    if(data) {
      this.buttonLabel = 'Сохранить';
      this.loadFiltered();
    }

    // this.filteredUniversities = this.form.controls.university.valueChanges.pipe(
    //   startWith(''),
    //   map(value => this._filterUniversity(value))
    // );

    this.filteredUniversityFields = this.form.controls.indicatorsFilter.valueChanges.pipe(
      startWith(''),
      map(value => this._filterUniversityField(value))
    );

    // this.form.valueChanges
    //   .pipe(
    //     takeUntil(this.destroyed$),
    //     debounceTime(350))
    //   .subscribe(
    //     this.loadFiltered.bind(this)
    //   );
  }

  ngOnInit(): void {
    this.database$.subscribe((v: Database) => {
      this.universitiesCount = v.universitiesCount - 1;
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  prepareOptions() {
    // this.universities$
    //   .pipe(
    //     switchMap((v: Array<University>) => from(v)
    //       .pipe(
    //         map((v: University) => v.name),
    //         reduce( (acc, v) => acc.concat(v), []),
    //       )
    //     )
    //   )
    //   .subscribe(v => this.universities = v);


    this.universityFields$
      .pipe(
        switchMap((v: Array<UniversityField>) => from(v)
          .pipe(
            filter( (v: UniversityField) => ['int', 'float', 'money'].includes(v.type)),
            // map((v: UniversityField) => v.name),
            reduce( (acc, v) => acc.concat(v), []),
          )
        )
      )
      .subscribe(v => {
        this.universityFields = [];
        for (let i = 0; i < v.length; i++) {

          this.universityFields.push(Object.assign({}, v[i], {public_name: v[i].name}))
        }

        // this.universityFields = v
      });
  }

  getPayload() {
    let payload = null;

    if(this.form.valid) {

      const valLabel = this.form.value.university;
      const count = this.dataSource.data.length;

      payload = {...this.form.value, label: `Университеты, похожие на ${valLabel}: ${count}`};
      payload.indicators = this.getIndicatorsValues(this.form.value.indicators);
      delete(payload.indicatorsFilter);
    }
    return payload;
  }

  get varLabel(): string {
    if(this.dataSource) {
      const count = this.dataSource.data.length;
      return `Найдено: ${count} ` + this.declOfNum(count, ['университет', 'университета', 'университетов'])
    }
    return '';
  }

  complete() {
    let promise = this.loadFiltered();
    promise.subscribe(response => {
      const payload = this.getPayload();

      this.dialogRef.close({data: payload});
    }, error1 => {
      const payload = this.getPayload();

      this.dialogRef.close({data: payload});
    });
  }

  // private _filterUniversity(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.universities.filter(option => option.toLowerCase().indexOf(filterValue) !== -1);
  // }

  private _filterUniversityField(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.universityFields.filter(option => option.toLowerCase().indexOf(filterValue) !== -1);
  }

  onIndicatorsPanelClose() {

  }

  getIndicatorsValues(names: Array<string>) {
    let values = [];

    this.universityFields$
    .pipe(
      switchMap((v: Array<UniversityField>) => from(v)
        .pipe(
          filter( (v: UniversityField) => names.includes(v.name)),
          map((v: UniversityField) => v.value),
          reduce( (acc, v) => acc.concat(v), []),
        )
      )
    )
    .subscribe(v => values = v);
    return values;
  }

  getIndicatorsNames(values: Array<string>) {
    let names = [];
    if(typeof values == 'object') {
      this.universityFields$
        .pipe(
          switchMap((v: Array<UniversityField>) => from(v)
            .pipe(
              filter((v: UniversityField) => values.includes(v.value)),
              map((v: UniversityField) => v.name),
              reduce((acc, v) => acc.concat(v), []),
            )
          )
        )
        .subscribe(v => names = v);
    }
    return names;
  }

  loadFiltered() : Subject<Object> | null {
    const payload = this.getPayload();
    if(payload) {
      this.loading = true;
      this.loaded = false;
      let promise = new Subject();
      this.coreService.loadFiltered({'fields': [{'indicator': 'country'}, {'indicator': 'name'}], 'filters': [payload]})
        .subscribe((response: []) => {
          this.loading = false;
          this.loaded = true;

          this.dataSource = new MatTableDataSource(response);
          promise.next(response);
        }, error1 => {
          promise.error({});
        });
      return promise;
    }
    return null;
  }

  declOfNum(number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
  }

  getUniversity() {
      const config = {
        width: '1100px',
        // autoFocus: true,
        data: {
          singleMode: true,
          val: this.form.controls.university.value || '',
          indicators: [],
          filters: []
        }
      };
      const dialogRef = this.dialog.open(FilterUniversityDialogComponent, config);
      dialogRef.afterClosed().subscribe(
      (val) => {
        if (val) {
          this.form.patchValue({university: val.data.val});
        }
      }
    );

  }

  selectIndicators() {
    let config = {
      width: '1100px',
      data: {
        ratings: this.universityFields.map(x => Object.assign({}, x, {value: x.name})),
        val: this.form.value.indicators,
      }
    };
    let dialogRef = this.dialog.open(RatingSelectDialogComponent, config);
    dialogRef.afterClosed().subscribe(
      (value) => {
        if (value) {
          this.form.patchValue({indicators: value.data.val.map(x => x.value)});
        }
      }
    );


  }
}
